import { PackageDetails } from "types/api.types";
import { SessionManager } from "./sessionManager";

/**
 * Auth tokens live in sessionStorage (not localStorage) to limit persistence
 * after browser restart. Refresh tokens use HttpOnly cookies — do not store them in JS.
 */
class LocalStorage {
  setApiKey(apiKey: string) {
    sessionStorage.setItem('API_KEY', apiKey);
    localStorage.removeItem('API_KEY');
    SessionManager.setLoginTime();
  }

  getApiKey(): string | null {
    return sessionStorage.getItem('API_KEY') || localStorage.getItem('API_KEY');
  }

  setRefreshKey(_apiKey: string) {
    // Refresh token is HttpOnly cookie only — ignore JS-side storage
    sessionStorage.removeItem('REFRESH_KEY');
    localStorage.removeItem('REFRESH_KEY');
  }

  getRefreshKey(): string | null {
    return null;
  }
  setUserId(userId: string) {
    localStorage.setItem('USER_ID', userId);
  }
  setRoles(roles: string) {
    localStorage.setItem('ROLES', roles);
  }

  getRoles(): string[] {
    const roles = localStorage.getItem('ROLES');
    if (roles) {
      try {
        const parsed = JSON.parse(roles);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch {
        return roles.split(',').map(role => role.trim()).filter(role => role);
      }
    }
    return [];
  }

  getUserId() {
    return localStorage.getItem('USER_ID');
  }

  setUserDetails(userDetails: any) {
    localStorage.setItem('USER', JSON.stringify(userDetails));
  }

  getUserDetails(): any | null {
    const user = localStorage.getItem('USER');
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }

  setCreatorOnboarding(data: any) {
    localStorage.setItem('CREATOR_ONBOARDING', JSON.stringify(data));
  }

  getCreatorOnboarding() {
    const creatorOnboarding = localStorage.getItem('CREATOR_ONBOARDING');
    if (creatorOnboarding) {
      return JSON.parse(creatorOnboarding);
    }
    return null;
  }

  setOnboardingDetails(data: any) {
    localStorage.setItem('USER_ONBOARDING', JSON.stringify(data));
  }

  getOnboardingDetails() {
    const user = localStorage.getItem('USER_ONBOARDING');
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }
  setMetaData(data: any) {
    localStorage.setItem('USER_METADATA', JSON.stringify(data));
  }

  getMetaData() {
    const user = localStorage.getItem('USER_METADATA');
    if (user) {
      return JSON.parse(user);
    }
    return null;
  }

  setPackageData(data: PackageDetails) {
    localStorage.setItem('PACKAGE_DATA', JSON.stringify(data));
  }

  getPackageData() {
    const packageData = localStorage.getItem('PACKAGE_DATA');
    if (packageData) {
      return JSON.parse(packageData);
    }
    return null;
  }

  clearPackageData() {
    localStorage.removeItem('PACKAGE_DATA');
  }

  logout() {
    SessionManager.clearSession();
    sessionStorage.removeItem('API_KEY');
    sessionStorage.removeItem('REFRESH_KEY');
    localStorage.clear();
  }
}

export default new LocalStorage();
